const navigationMixin = (Base = class Empty {}) => class extends Base {

	injectNavigation(navigation) {
		this.navigation = navigation;
	}

};

export default navigationMixin;
